import { render } from "./CreateResourceModal.vue?vue&type=template&id=6fa9c71e"
import script from "./CreateResourceModal.vue?vue&type=script&lang=js"
export * from "./CreateResourceModal.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"CreateResourceModal.vue"]])

export default __exports__